import { render, staticRenderFns } from "./AIPromptInput.vue?vue&type=template&id=1579fb06&scoped=true&"
import script from "./AIPromptInput.vue?vue&type=script&lang=js&"
export * from "./AIPromptInput.vue?vue&type=script&lang=js&"
import style0 from "./AIPromptInput.vue?vue&type=style&index=0&id=1579fb06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1579fb06",
  null
  
)

export default component.exports